<template>
  <div class="media-library-item-fi">
    <div
      :class="{
        'media-library-item-fi__media-container': true,
        'media-library-item-fi__media-container--brand-bg': socialMediaLogo || isVideoLink,
        'media-library-item-fi__media-container--no-image':
          (!fileUrl || !isImageFile) && !isVideoLink && !socialMediaLogo,
        'media-library-item-fi--is-newsroom': isNewsroom,
      }"
    >
      <img
        v-if="socialMediaLogo"
        class="media-library-item-fi__media-icon"
        :src="socialMediaLogo"
        :alt="itemTitle"
      />
      <cloud-image-fi
        v-else-if="image || (fileUrl && isImageFile)"
        class="media-library-item-fi__media"
        :src="image || fileUrl"
        :alt="itemTitle"
        :params="cloudImageParams"
      />
      <template v-else>
        <img
          v-if="!isVideoLink"
          :src="placeholderImage"
        />
      </template>
      <div
        v-if="isVideoLink"
        class="media-library-item-fi__video-overlay-button"
      >
        <icon-fi
          class="media-library-item-fi__video-icon"
          icon="youtube-logo"
        />
      </div>
    </div>
    <div class="media-library-item-fi__content">
      <div class="media-library-item-fi__title">
        {{ itemTitle }}
      </div>

      <div
        v-if="fileUrl"
        class="media-library-item-fi__file-size"
      >
        <span>{{ getFileSizeAndLabel(fileSizeInBytes) }}</span>
        <span>{{ fileExtension }}</span>
      </div>

      <div class="media-library-item-fi__footer">
        <div
          v-if="itemSource"
          class="media-library-item-fi__file-source"
        >
          <template v-if="fileUrl && isImageFile">
            {{ $dict.get('media-Library.Items.Source-Label-Images') }}
          </template>
          <template v-else>
            {{ $dict.get('media-Library.Items.Source-Label-File') }}
          </template>
          {{ itemSource }}
        </div>

        <div class="media-library-item-fi__controls">
          <a
            v-if="externalLink"
            :href="externalLink"
            class="button-fi__icon button-fi__primary"
            target="__blank"
          >
            <icon-fi icon="link" />
          </a>

          <template v-else>
            <button-fi
              v-if="(fileUrl && isImageFile) || isNewsroom"
              class="media-library-item-fi__zoom-in button-fi__icon button-fi__tertiary"
              @click="onZoomImage"
            >
              <icon-fi icon="zoom-in" />
            </button-fi>

            <a
              v-if="downloadUrl"
              :href="downloadUrl"
              class="button-fi__icon button-fi__primary"
              download
              @click="handleDownload"
            >
              <icon-fi icon="download" />
            </a>
          </template>
        </div>
      </div>
    </div>
    <media-library-zoom-image-dialog-fi
      v-if="!disbaleDialog && downloadUrl"
      ref="mediaLibraryZoomImageDialog"
      :item="item"
    />
  </div>
</template>

<script>
import { ButtonFi, CloudImageFi, IconFi } from 'atoms';
import MediaLibraryZoomImageDialogFi from 'components/media-library-zoom-image-dialog-fi/MediaLibraryZoomImageDialogFi';
import mediaLibraryMixin from 'mixins/mediaLibraryMixin';

import getAssetUrl from '@/lib/AssetService';
import trackingMixin from '@/mixins/trackingMixin.vue';
import theme from '@/plugins/tailwind-theme';

export default {
  name: 'MediaLibraryItemFi',
  components: {
    ButtonFi,
    CloudImageFi,
    IconFi,
    MediaLibraryZoomImageDialogFi,
  },
  mixins: [mediaLibraryMixin, trackingMixin],
  inject: ['fields'],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    disbaleDialog: {
      type: Boolean,
      default: false,
    },
    isNewsroom: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['show-zoom-dialog'],
  data() {
    return {
      placeholderImage: getAssetUrl('/img/products/placeholder.svg'),
    };
  },
  computed: {
    enableYoutubeLogo() {
      return this.item?.fields?.showYoutubeLogo?.value;
    },
    enableFacebookLogo() {
      return this.item?.fields?.showFacebookLogo?.value;
    },
    enableInstagramLogo() {
      return this.item?.fields?.showInstagramLogo?.value;
    },
    enableTwitterLogo() {
      return this.item?.fields?.showTwitterLogo?.value;
    },
    socialMediaLogo() {
      let url;

      if (this.enableYoutubeLogo) {
        url = getAssetUrl('/img/media-library/youtube-logo.svg');
      } else if (this.enableFacebookLogo) {
        url = getAssetUrl('/img/media-library/facebook-logo.svg');
      } else if (this.enableInstagramLogo) {
        url = getAssetUrl('/img/media-library/instagram-logo.svg');
      } else if (this.enableTwitterLogo) {
        url = getAssetUrl('/img/media-library/twitter-logo.svg');
      } else {
        url = null;
      }

      return url;
    },
    externalLink() {
      return (
        this.item?.fields?.externalLink?.value?.href || this.item?.fields?.externalLink?.value?.url
      );
    },
    isVideoLink() {
      return this.item?.fields?.isVideoLink?.value;
    },
    downloadUrl() {
      return this.isNewsroom ? this.image : this.fileUrl;
    },
    cloudImageParams() {
      return `func=fit&bg_color=${theme.fiwe.grey}&aspect_ratio=16:9`;
    },
  },
  methods: {
    onZoomImage() {
      if (!this.disbaleDialog) {
        this.$refs.mediaLibraryZoomImageDialog.show();
      } else {
        this.$emit('show-zoom-dialog', this.item);
      }
    },
    handleDownload() {
      this.sendEvent('custom', {}, 'download', {
        link: this.downloadUrl,
      });
    },
  },
};
</script>

<style lang="scss">
@import './media-library-item-fi-unscoped';
</style>

<style scoped lang="scss">
@import './media-library-item-fi';
</style>
